var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8335 22.6654L22.6668 16.832M16.8335 22.6654V17.6654C16.8335 17.4444 16.9213 17.2324 17.0776 17.0761C17.2339 16.9198 17.4458 16.832 17.6668 16.832H22.6668M16.8335 22.6654H11.0002C10.5581 22.6654 10.1342 22.4898 9.82165 22.1772C9.50909 21.8646 9.3335 21.4407 9.3335 20.9987V10.9987C9.3335 10.5567 9.50909 10.1327 9.82165 9.82019C10.1342 9.50763 10.5581 9.33203 11.0002 9.33203H21.0002C21.4422 9.33203 21.8661 9.50763 22.1787 9.82019C22.4912 10.1327 22.6668 10.5567 22.6668 10.9987V16.832M12.3302 13.3287H18.4777M12.3302 17.3286H13.9894",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote32);
export default __webpack_public_path__ + "static/media/note-32.325487576586d640cd6dd6f29aed2c70.svg";
export { ForwardRef as ReactComponent };